var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMA)?_c('div'):_c('div',[_c('img',{attrs:{"src":`${_vm.publicPath}logo.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }